import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {UsersListHeader} from './components/header/UsersListHeader'
import {UsersTable} from './table/UsersTable'
import {UserEditModal} from './user-edit-modal/UserEditModal'
import {BulkRequesterUploadModal} from './components/BulkRequesterUploadModal'
import {KTCard} from '../../../../_metronic/helpers'
import {useState} from 'react'
import {useQueryResponse} from './core/QueryResponseProvider'

const UsersList: React.FC<Props> = ({userType, customerCode}) => {
  const {itemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false)

  return (
    <>
      <KTCard>
        <UsersListHeader
          customerCode={customerCode}
          userType={userType}
          onOpenBulkUpload={() => setBulkUploadOpen(true)}
        />
        <UsersTable userType={userType} customerCode={customerCode}/>
      </KTCard>
      {itemIdForUpdate !== undefined && (
        <UserEditModal userType={userType} customerCode={customerCode} />
      )}
      {userType === 'CONSUMER' && (
        <BulkRequesterUploadModal
          open={bulkUploadOpen}
          onClose={() => setBulkUploadOpen(false)}
          onComplete={() => {
            refetch()
          }}
        />
      )}
    </>
  )
}

type Props = {
  userType: string
  customerCode: number
}

const UsersListWrapper: React.FC<Props> = ({userType, customerCode}) => (
  <QueryRequestProvider>
    <QueryResponseProvider userType={userType} customerCode={customerCode}>
      <ListViewProvider>
        <UsersList userType={userType} customerCode={customerCode} />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {UsersListWrapper}
